export const Add = ({ width, height, viewBox, fill, styles }) => {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      viewBox={viewBox || '0 0 40 40'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <g clipPath="url(#clip0_5473_2922)">
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="black"
          strokeOpacity="0.05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 11.75C20.4142 11.75 20.75 12.0858 20.75 12.5V19.25H27.5C27.9142 19.25 28.25 19.5858 28.25 20C28.25 20.4142 27.9142 20.75 27.5 20.75H20.75V27.5C20.75 27.9142 20.4142 28.25 20 28.25C19.5858 28.25 19.25 27.9142 19.25 27.5V20.75H12.5C12.0858 20.75 11.75 20.4142 11.75 20C11.75 19.5858 12.0858 19.25 12.5 19.25H19.25V12.5C19.25 12.0858 19.5858 11.75 20 11.75Z"
          fill={fill || '#C1C1C1'}
        />
      </g>
      <defs>
        <clipPath id="clip0_5473_2922">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
